module.exports = __webpack_public_path__ + "13b240062f9cf9a7f4131b86a426f140.svg";